/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AddPimImportMutationVariables = Types.Exact<{
  input: Types.AddPimImportInput;
}>;


export type AddPimImportMutation = { addPimImport: { __typename: 'AddPimImportationResult', importation: { __typename: 'PimImportation', id: string, url: string, status: Types.PimImportationStatus, filename: string } } };

export type PimRequestImportationUploadUrlMutationVariables = Types.Exact<{
  input: Types.PimRequestImportationUploadUrlInput;
}>;


export type PimRequestImportationUploadUrlMutation = { pimRequestImportationUploadUrl: { __typename: 'RequestUploadUrlResult', uploadUrl: string } };


export const AddPimImportDocument = gql`
    mutation AddPimImport($input: AddPimImportInput!) {
  addPimImport(input: $input) {
    importation {
      id
      url
      status
      filename
    }
  }
}
    `;
export type AddPimImportMutationFn = Apollo.MutationFunction<AddPimImportMutation, AddPimImportMutationVariables>;

/**
 * __useAddPimImportMutation__
 *
 * To run a mutation, you first call `useAddPimImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPimImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPimImportMutation, { data, loading, error }] = useAddPimImportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddPimImportMutation(baseOptions?: Apollo.MutationHookOptions<AddPimImportMutation, AddPimImportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPimImportMutation, AddPimImportMutationVariables>(AddPimImportDocument, options);
      }
export type AddPimImportMutationHookResult = ReturnType<typeof useAddPimImportMutation>;
export type AddPimImportMutationResult = Apollo.MutationResult<AddPimImportMutation>;
export type AddPimImportMutationOptions = Apollo.BaseMutationOptions<AddPimImportMutation, AddPimImportMutationVariables>;
export const PimRequestImportationUploadUrlDocument = gql`
    mutation PimRequestImportationUploadUrl($input: PimRequestImportationUploadUrlInput!) {
  pimRequestImportationUploadUrl(input: $input) {
    uploadUrl
  }
}
    `;
export type PimRequestImportationUploadUrlMutationFn = Apollo.MutationFunction<PimRequestImportationUploadUrlMutation, PimRequestImportationUploadUrlMutationVariables>;

/**
 * __usePimRequestImportationUploadUrlMutation__
 *
 * To run a mutation, you first call `usePimRequestImportationUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePimRequestImportationUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pimRequestImportationUploadUrlMutation, { data, loading, error }] = usePimRequestImportationUploadUrlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePimRequestImportationUploadUrlMutation(baseOptions?: Apollo.MutationHookOptions<PimRequestImportationUploadUrlMutation, PimRequestImportationUploadUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PimRequestImportationUploadUrlMutation, PimRequestImportationUploadUrlMutationVariables>(PimRequestImportationUploadUrlDocument, options);
      }
export type PimRequestImportationUploadUrlMutationHookResult = ReturnType<typeof usePimRequestImportationUploadUrlMutation>;
export type PimRequestImportationUploadUrlMutationResult = Apollo.MutationResult<PimRequestImportationUploadUrlMutation>;
export type PimRequestImportationUploadUrlMutationOptions = Apollo.BaseMutationOptions<PimRequestImportationUploadUrlMutation, PimRequestImportationUploadUrlMutationVariables>;